import { Component } from '@angular/core';

@Component({
  selector: 'adkom-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent {}
